module.exports = __webpack_public_path__ + "static/hero-image.398994dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-image.jpg
// module id = 119
// module chunks = 35783957827783 263791100135453